import {v4} from 'uuid';

const uuid: () => string = v4 as any;

export default uuid;
